import { useEffect, useState } from 'react';
import {
    API_ACTIONS,
    DESIGN_BOARD_REMIX_API,
} from '~/modules/design-board/config';
import { Dialog } from '@archipro-design/aria';
import { useDesignBoardPageState } from '~/modules/design-board/component/context';
import { useFetcher } from '@remix-run/react';
import type { DeleteItemFromDesignBoardMutation } from 'generated/graphql';
import { DeleteDesignBoardDialog } from '~/modules/design-board/component/right-side-drawer/DeleteDesignBoardDialog';
import { useToaster } from '~/modules/root/context/ToasterContext';
import { useTracker } from '@archipro-website/tracker';
import { fetcherIsDone } from '~/utils/fetcherHelper';
import { clearAllDesignBoardCache } from '@rocco/ui/design-board/components/DesignBoardsActions';

export const useDeletePin = () => {
    const { dispatch } = useDesignBoardPageState();
    const deleteFetcher = useFetcher<DeleteItemFromDesignBoardMutation>();
    const { toast } = useToaster();
    const tracker = useTracker();

    const onDelete = (pinIds = pinsToDelete) => {
        tracker.log('PinDelete', {
            url: new URL(window.location.href),

            data: {
                ElementID: 'designboard_detail_header_deletePin',

                Source: 'designBoard, detail',
            },
        });
        deleteFetcher.submit(
            {
                pinIds,
                _action: API_ACTIONS.DELETE_DESIGN_BOARD_PINS,
            },
            {
                method: 'post',
                action: DESIGN_BOARD_REMIX_API,
            }
        );

        clearAllDesignBoardCache();
    };
    const [pinsToDelete, setPinsToDelete] = useState<string>('');

    const modalClose = () => setPinsToDelete('');

    useEffect(() => {
        if (fetcherIsDone(deleteFetcher)) {
            dispatch({ type: 'CloseDrawer' });
            toast('Pin deleted', { type: 'success' });
            modalClose();
        }
    }, [deleteFetcher, dispatch, toast]);

    const deletePin = (pinIds: string | number) => {
        pinIds && setPinsToDelete(pinIds.toString());
    };

    const deletePinDialog = (className?: string) => (
        <Dialog
            open={pinsToDelete !== ''}
            onCancel={() => modalClose()}
            content={
                <DeleteDesignBoardDialog
                    modalHeader={
                        pinsToDelete.includes(',')
                            ? `Delete Pins`
                            : `Delete Pin`
                    }
                    modalContent={
                        pinsToDelete.includes(',')
                            ? `Are you sure you would like to delete these pins from this board?`
                            : `Are you sure you would like to delete this pin from this board?`
                    }
                    onDelete={() => {
                        onDelete && onDelete();
                    }}
                    onCancel={() => modalClose()}
                />
            }
            className={className}
            footer={null}
            header={null}
        />
    );

    return {
        deletePin,
        deleteFetcher,
        deletePinDialog,
    };
};
